export const query = (selector, element = document) =>
  element.querySelector(selector);

export const queryAll = (selector, element = document) => {
  const nodeList = element.querySelectorAll(selector);
  return Array.from(nodeList);
};

export const ready = (onReady) => {
  if (document.readyState === "complete") {
    onReady();
  } else {
    window.addEventListener("load", () => {
      onReady();
    });
  }
};
